// extracted by mini-css-extract-plugin
export default {"leftButton":"style_leftButton__xA8wa","btn_back":"style_btn_back__hvk2Y","leftButton_lection":"style_leftButton_lection__U2MJ-"};